import { ReactNode } from 'react';
import FormFooter from '../../../common/FormFooter';
import StepOne from './StepOne';
import StepTwo from './StepTwo';
import StepThree from './StepThree';
import { PackingListInterface } from '../../../../../../pages/dashboard/tradedocuments/tradeDocumentTypes/parkinglistTypes';

const PackingListMobileForm = ({
    error,
    updateField,
    payload,
    corporatePartners,
    countries,
    isCountriesLoading,
    loadingCorporatepartners,
    setShowAddPartner,
    errors,
    quoteFields,
    updateQuoteField,
    removeQuoteField,
    addQuoteField,
    setSignatureUrlBase64,
    signatureUrlBase64,
    totalNetWeight,
    totalUnitQuantity,
    totalGrossWeight,
    totalVolume,
    activeStep,
    setActiveStep,
    onSaveOnlyAction,
    setShowPreview,
    showPreview
}: PackingListInterface) => {
    const views: {
        [key: number]: ReactNode;
    } = {
        0: (
            <StepOne
                {...{
                    error,
                    updateField,
                    payload,
                    corporatePartners,
                    countries,
                    isCountriesLoading,
                    loadingCorporatepartners,
                    setShowAddPartner,
                    errors,
                    quoteFields,
                    updateQuoteField,
                    removeQuoteField,
                    addQuoteField,
                    setSignatureUrlBase64,
                    signatureUrlBase64,
                    totalNetWeight,
                    totalUnitQuantity,
                    totalGrossWeight,
                    totalVolume,
                    activeStep,
                    setActiveStep,
                    onSaveOnlyAction,
                    setShowPreview,
                    showPreview
                }}
            />
        ),
        1: (
            <StepTwo
                {...{
                    error,
                    updateField,
                    payload,
                    corporatePartners,
                    countries,
                    isCountriesLoading,
                    loadingCorporatepartners,
                    setShowAddPartner,
                    errors,
                    quoteFields,
                    updateQuoteField,
                    removeQuoteField,
                    addQuoteField,
                    setSignatureUrlBase64,
                    signatureUrlBase64,
                    totalNetWeight,
                    totalUnitQuantity,
                    totalGrossWeight,
                    totalVolume,
                    activeStep,
                    setActiveStep,
                    onSaveOnlyAction,
                    setShowPreview,
                    showPreview
                }}
            />
        ),
        2: (
            <StepThree
                {...{
                    error,
                    updateField,
                    payload,
                    corporatePartners,
                    countries,
                    isCountriesLoading,
                    loadingCorporatepartners,
                    setShowAddPartner,
                    errors,
                    quoteFields,
                    updateQuoteField,
                    removeQuoteField,
                    addQuoteField,
                    setSignatureUrlBase64,
                    signatureUrlBase64,
                    totalNetWeight,
                    totalUnitQuantity,
                    totalGrossWeight,
                    totalVolume,
                    activeStep,
                    setActiveStep,
                    onSaveOnlyAction,
                    setShowPreview,
                    showPreview
                }}
            />
        )
    };

    return (
        <div className='lg:hidden pt-4'>
            {views[activeStep]}
            <FormFooter
                onContinue={() => {
                    setActiveStep(activeStep + 1);
                }}
                onSave={() => onSaveOnlyAction && onSaveOnlyAction()}
                onPreview={() => setShowPreview(!showPreview)}
                onGoBack={() => {
                    setActiveStep(activeStep - 1);
                }}
                steps={3}
                activeStep={activeStep}
                disabled={Object.values(payload).some(
                    (item) => item === undefined
                )}
            />
        </div>
    );
};

export default PackingListMobileForm;
